const pubsub = require('pubsub-js');
const { pushEvent } = require('../utils/pushEvent');

function hotelSubscriptions() {
    pubsub.subscribe('Hotel', pushEvent);
}

module.exports = { hotelSubscriptions };